import React from "react";
import ClayIcon from "@clayui/icon";
import classNames from "classnames";
import "./MultiStep.css";

interface Props {
  step: number;
  setStep: (stepIndex: number) => void;
}

const MultiStep: React.FC<Props> = ({ step, setStep }) => {
  const steps = ['Basic Information', 'Email Verification', 'Business Details'];

  return (
      <div className="wrapper">
          <ol className="c-stepper">
              {steps.map((label, index) => {
                  const isActive = step === index;
                  const isComplete = step > index;

                  return (
                      <li
                          key={index}
                          className={classNames('c-stepper__item', {
                              active: isActive,
                              complete: isComplete
                          })}
                          onClick={() => {
                              if (step > index) setStep(index);
                          }}
                      >
                          {/* Circle Content */}
                          <div className="step-circle-content">
                              {isComplete ? (
                                  <ClayIcon symbol="check" />
                              ) : (
                                  <span>{index + 1}</span>
                              )}
                          </div>

                          {/* Label */}
                          <h3 className="c-stepper__title">{label}</h3>
                      </li>
                  );
              })}
          </ol>
      </div>
  );
};

export default MultiStep;